import regenerateSettlement from './regenerateSettlement';
import transactionReconciliation from './transactionReconciliation';

const reconciliation = {
  namespaced: true,

  state() {
    return {
      isPageLoaded: false,
    };
  },

  mutations: {
    setIsLoadedPage(state, loadedPage) {
      state.isPageLoaded = loadedPage;
    },
  },

  actions: {},

  modules: {
    regenerateSettlement,
    transactionReconciliation,
  },
};

export default reconciliation;
